export enum ResponsibleOrganisationLocation {
  Presidency = 'Prime Minister, Presidency or Chancellery',
  Ministry = 'Ministry',
  SeveralMinistries = 'Several ministries',
  MultiplePublic = 'Multiple public and private stakeholders',
  Other = 'Other'
}
